import React from "react";
import Text from "@amzn/meridian/text";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Box from "@amzn/meridian/box";
import Link from "@amzn/meridian/link";
import { FAQs } from "../../../shared/constants/messages";
import {
  generateKey,
  openInNewTab,
  MY_HR,
  A_TO_Z,
  TABLET_BREAKPOINT,
  ControlledSectionExpander,
  MOBILE_BREAKPOINT,
} from "src/components/shared";
import useBreakpoint from "@amzn/meridian/use-breakpoint";
import { useBundle } from "@amzn/react-arb-tools";
import { scrollToElement } from "src/components/shared/utils/utils";
import {
  HOMEPAGE_MESSAGE_BUNDLE_NAME,
  POLICYPAGE_MESSAGE_BUNDLE_NAME,
} from "src/constants";
import { t } from "src/helpers";

const FAQ = () => {
  const [bundle_home] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);
  const [bundle_policy] = useBundle(POLICYPAGE_MESSAGE_BUNDLE_NAME);
  const isTablet = useBreakpoint(TABLET_BREAKPOINT) === "smaller";
  const isMobile = useBreakpoint(MOBILE_BREAKPOINT) === "smaller";
  const type = isMobile ? "h500" : isTablet ? "h500" : "h600";

  const withLink = (index) => index === 0 || index === 3;
  const targetElement = isTablet
    ? "heresHowItWorksNonDesktopElement"
    : "heresHowItWorksElement";

  return (
    <Row
      widths={isMobile ? ["grid-1", "grid-10"] : ["grid-2", "grid-8"]}
      backgroundColor="#F5F5F5"
    >
      <Column></Column>
      <Box id="hoem_faq" spacingInset={"600 none 600 none"}>
        <Column spacing="500">
          <Text type={type} fontFamily={"bookerly"}>
            {t(bundle_home, "frequently_asked_questions")}
          </Text>
          <Column spacing="400">
            {FAQs.map((faq, index) => (
              <ControlledSectionExpander
                key={generateKey(index)}
                title={<Text type="h100">{t(bundle_home, faq[0])}</Text>}
              >
                {!withLink(index) ? (
                  <Text type="b300">{t(bundle_home, faq[1])}</Text>
                ) : index === 3 ? (
                  <Text type="b300">
                    {t(bundle_home, faq[1])}{" "}
                    <Link onClick={() => openInNewTab(MY_HR)}>
                      {t(bundle_policy, "myhr")}
                    </Link>{" "}
                    {t(bundle_policy, "or")}{" "}
                    <Link onClick={() => openInNewTab(A_TO_Z)}>
                      {t(bundle_policy, "atoz")}
                    </Link>{" "}
                    {t(bundle_home, faq[2])}
                  </Text>
                ) : (
                  <Text type="b300">
                    {t(bundle_home, faq[1])}{" "}
                    <Link onClick={() => scrollToElement(targetElement)}>
                      {t(bundle_home, faq[2])}
                    </Link>{" "}
                    {t(bundle_home, faq[3])}
                  </Text>
                )}
              </ControlledSectionExpander>
            ))}
            <Row></Row>
          </Column>
        </Column>
      </Box>
    </Row>
  );
};

export default FAQ;
